import { push } from 'connected-react-router';
import { deleteForm as serverDeleteForm } from 'api/taxi.backend';
import { showNotification } from 'containers/NotificationEngine/actions';
import {
  NOTIFICATION_TYPE_GENERAL,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TIMEOUT_NONE,
  NOTIFICATION_TIMEOUT_DEFAULT,
} from 'containers/NotificationEngine/constants';
import { getCredentialTypeIdFromUrl } from 'utils/redirects';

export const handleDeleteForm = async (dispatch, id, groupingId) => {
  const credentialTypeId = getCredentialTypeIdFromUrl();
  try {
    await serverDeleteForm(id);
    dispatch(showNotification(
      'taxi-success-delete-form',
      NOTIFICATION_TYPE_GENERAL,
      'Form Deleted.',
      NOTIFICATION_TIMEOUT_DEFAULT,
      null,
      null
    ));
    dispatch(push(`/credential-type/${credentialTypeId}/groupings/${groupingId}/forms`));
  } catch (error) {
    console.log(error); // eslint-disable-line no-console
    dispatch(showNotification(
      'taxi:err-delete-form',
      NOTIFICATION_TYPE_ERROR,
      'Unable to Delete Form.',
      NOTIFICATION_TIMEOUT_NONE,
      null,
      null
    ));
  }
};
